import { OrganizationMemberClientAccessSource } from "@common/types/organizationMemberClientAccess";
import { getOrganizationTaskLink } from "@components/organizationView/clients-tasks/organizationTaskLink";
import type { SideNavTarget } from "@design-system/SideNav/SideNav.types";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { useScope } from "@state/scopeContext.lib";

/**
 * Where a client's task row in the org side nav goes: the task on the org
 * Actions page when close management is on, otherwise the task on the
 * client's own Actions page after switching into the client.
 */
export const useClientTaskTarget = (workspaceId: string) => {
    const { closeManagement: isCloseManagementEnabled } = useTypedFlags();
    const { changeActiveWorkspace } = useScope();
    const navigate = useStateAwareNavigate();

    return (taskId: string): SideNavTarget => {
        if (isCloseManagementEnabled) {
            return { to: getOrganizationTaskLink({ taskId, workspaceId }) };
        }
        return {
            onClick: () => {
                changeActiveWorkspace(
                    workspaceId,
                    OrganizationMemberClientAccessSource.SWITCHER,
                );
                navigate(`/?taskId=${taskId}`);
            },
        };
    };
};
